import { keepPreviousData, useQuery } from '@tanstack/react-query';
import * as Api from '../api';
import type { PeopleParams, PeopleResponse } from '../types';

interface IProps {
  orgId?: string;
  params: PeopleParams;
  enabled?: boolean;
}

const usePeople = ({ orgId, params, enabled = true }: IProps) =>
  useQuery<PeopleResponse>({
    queryKey: ['analytics', 'people', orgId, params],
    queryFn: async () => {
      const { data } = await Api.GetPeople(params);
      return data;
    },
    enabled: !!orgId && enabled,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });

export default usePeople;
